'use strict';

import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnEconomicPeriodTable = function () {

    var tableName = '#datatable-economic-period-status';

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    var columns = [
        {data: 'name'},
        {data: 'january'},
        {data: 'february'},
        {data: 'march'},
        {data: 'april'},
        {data: 'may'},
        {data: 'june'},
        {data: 'july'},
        {data: 'august'},
        {data: 'september'},
        {data: 'october'},
        {data: 'november'},
        {data: 'december'},
        {data: 'year'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {visible: true, targets: 0, width: "35%"},
        {visible: true, targets: 1},
        {visible: true, targets: 2},
        {visible: true, targets: 3},
        {visible: true, targets: 4},
        {visible: true, targets: 5},
        {visible: true, targets: 6},
        {visible: true, targets: 7},
        {visible: true, targets: 8},
        {visible: true, targets: 9},
        {visible: true, targets: 10},
        {visible: true, targets: 11},
        {visible: true, targets: 12},
        {visible: true, targets: 13},
    ];

    console.log('here');
    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');

    var form = $('#form-check-economic-period-status');

    var baseUrl = '/economic-period/load-table/';
    var year = -1;

    var table = $(tableName).DataTable({

        language: allLangFiles.datatables,
        rowId: 'id',
        ajax: {
            url: baseUrl + year,
            dataSrc: function (json) {

                return json.data;
            },
        },
        deferLoading: 0,
        columns: columns,
        columnDefs: columnDefs,
        /*scrollX: true,*/
        lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
    });

    const { $filterButtons } = redesignDataTablesHeader(tableName, false, null, false);

    form.off('submit')
        .on('submit', function (e) {
            e.preventDefault();
            table.clear().draw();
            $(tableName).find('tbody').html('<tr><td colspan="14" class="text-center">' + allLangFiles.datatables.loadingRecords + '</td></tr>');
            table.ajax.url(baseUrl + form.find('select[name="year"]').val()).load();
            // table.ajax.reload(null, false);
        })
    // addSearchColumn(tableName, table);
    // addExportBtns($(tableName));
};